import { useEffect } from 'react';
import PropTypes from 'prop-types';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { POSTHOG_KEY, POSTHOG_HOST, POSTHOG_ENABLED } from 'src/config-global';

import { shouldEnablePostHog } from './should-enable-posthog';

// ----------------------------------------------------------------------

// Decided once per page load. When this is false posthog.init never runs, and
// every posthog.* call elsewhere (identify, reset, captureException) is a no-op.
const POSTHOG_ACTIVE = shouldEnablePostHog({
  key: POSTHOG_KEY,
  hostname: window.location.hostname,
  override: POSTHOG_ENABLED,
});

export default function PostHogProvider({ children }) {
  useEffect(() => {
    if (POSTHOG_ACTIVE) {
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST || 'https://us.i.posthog.com',
        capture_pageview: true,
        capture_pageleave: true,
        // Uncaught errors and unhandled promise rejections become $exception events.
        capture_exceptions: true,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
          maskTextFn: (text, element) => {
            if (element?.dataset.capture === 'true') {
              return text;
            }
            return '*'.repeat(text.trim().length);
          },
        },
      });
    }
  }, []);

  if (!POSTHOG_ACTIVE) {
    return children;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}

PostHogProvider.propTypes = {
  children: PropTypes.node,
};
